import React from "react";
import { AutocompleteInput, ReferenceInput } from "react-admin";
import { useFormState } from "react-final-form";

const NextLevelInput = (props: any) => {
  const { values } = useFormState();

  return (
    <ReferenceInput
      label="Select Next Level"
      source="nextLevelId"
      reference="levels"
      filter={{
        SchoolId: Number(values.schoolId),
      }}
      allowEmpty
    >
      <AutocompleteInput optionText="name" />
    </ReferenceInput>
  );
};

export default NextLevelInput;
